// @flow

import InlineDialog from "@atlaskit/inline-dialog";
import React, { Component } from "react";
import Select from "@atlaskit/select";
import Spinner from "@atlaskit/spinner";
import { jitsiLocalStorage } from "lib-js-utils/jitsi-local-storage";
import axios from "axios";
import { flagsService, meetingService } from "../../../../../service";
import { createToolbarEvent, sendAnalytics } from "../../../analytics";
import { LogoutButton } from "../../../base/buttons/LogoutButton";
import { getRoomName } from "../../../base/conference";
import { IconPlus } from "../../../base/icons";
import {
    beginAddPeople as beginAddPeopleAction,
    clearAllInvitedUsers
} from "../../../invite";
import {
    editProfile as editProfileAction,
    editScurity as editScurityAction,
} from "../../../invite";
import { mediaPermissionPromptVisibilityChanged } from "../../../overlay";
import AudioSettingsButton from "../../../toolbox/components/web/AudioSettingsButton";
import { isButtonEnabled } from "../../../toolbox/functions.web";
import { muteLocal } from "../../../video-menu/actions.any";
import DeviceStatus from "./preview/DeviceStatus";
import MeetingPicker, { meetingErrorText } from "./MeetingPicker";

import { Avatar } from "../../../base/avatar";
import { isNameReadOnly } from "../../../base/config";
import { translate } from "../../../base/i18n";
import {
    IconArrowDown,
    IconArrowUp,
    IconPhoneRinging,
    IconVolumeOff,
} from "../../../base/icons";
import { isVideoMutedByUser, MEDIA_TYPE } from "../../../base/media";
import { getLocalParticipant } from "../../../base/participants";
import {
    ActionButton,
    InputField,
    PreMeetingScreen,
    ToggleButton,
} from "../../../base/premeeting";
import { connect } from "../../../base/redux";
import { getDisplayName, updateSettings } from "../../../base/settings";
import {
    createLocalTracksF,
    getLocalJitsiVideoTrack,
} from "../../../base/tracks";
import Button from "../../../base/ui/components/web/Button";
import { BUTTON_TYPES } from "../../../base/ui/constants.any";
import {
    joinConference as joinConferenceAction,
    joinConferenceWithoutAudio as joinConferenceWithoutAudioAction,
    // setSkipPrejoin as setSkipPrejoinAction,
    setJoinByPhoneDialogVisiblity as setJoinByPhoneDialogVisiblityAction,
} from "../../actions";
import {
    isDeviceStatusVisible,
    isDisplayNameRequired,
    isJoinByPhoneButtonVisible,
    isJoinByPhoneDialogVisible,
    isPrejoinDisplayNameVisible,
} from "../../functions";

import JoinByPhoneDialog from "./dialogs/JoinByPhoneDialog";

type Props = {
    /**
     * Indicates whether the display  name is editable.
     */
    canEditDisplayName: boolean,

    /**
     * Flag signaling if the device status is visible or not.
     */
    deviceStatusVisible: boolean,

    /**
     * If join by phone button should be visible.
     */
    hasJoinByPhoneButton: boolean,

    /**
     * Joins the current meeting.
     */
    joinConference: Function,

    /**
     * Joins the current meeting without audio.
     */
    joinConferenceWithoutAudio: Function,

    /**
     * Whether conference join is in progress.
     */
    joiningInProgress: boolean,

    /**
     * The name of the user that is about to join.
     */
    name: string,

    /**
     * Updates settings.
     */
    updateSettings: Function,

    /**
     * clear users.
     */
    clearInvitedUsers: Function,

    /**
     * The name of the meeting that is about to be joined.
     */
    roomName: string,

    /**
     * Local participant id.
     */
    participantId: string,

    /**
     * The prejoin config.
     */
    prejoinConfig?: Object,

    /**
     * Whether the name input should be read only or not.
     */
    readOnlyName: boolean,

    /**
     * Sets visibility of the 'JoinByPhoneDialog'.
     */
    setJoinByPhoneDialogVisiblity: Function,

    /**
     * Flag signaling the visibility of camera preview.
     */
    showCameraPreview: boolean,

    /**
     * If should show an error when joining without a name.
     */
    showErrorOnJoin: boolean,

    /**
     * If 'JoinByPhoneDialog' is visible or not.
     */
    showDialog: boolean,

    /**
     * Used for translation.
     */
    t: Function,

    /**
     * The JitsiLocalTrack to display.
     */
    videoTrack: ?Object,
    dispatch: ?any,
    moderatorMode: string,
    _user: Object,
};

type State = {
    /**
     * Flag controlling the visibility of the 'join by phone' buttons.
     */
    showJoinByPhoneButtons: boolean,
};

/**
 * This component is displayed before joining a meeting.
 */
class Prejoin extends Component<Props, State> {
    static defaultProps = {
        showConferenceInfo: true,
        showJoinActions: true,
        showSkipPrejoin: true,
    };

    /**
     * Initializes a new {@code Prejoin} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);

        this.state = {
            showJoinByPhoneButtons: false,
            name: jitsiLocalStorage.getItem("gaglTitleName"),
            loading: false,
            error: false,
            isCodec: true,
            moderatorMode: {
                label: this.props.moderatorMode?.toUpperCase(),
                value: this.props.moderatorMode,
            },
            userCreated: this.props.userCreated,
            previousmembers: [],
            toInvitePreviousMembersList: [],
            clickedUser: [],
            resendInviteClicked: false,
            // v1.0 section 4.2.3: the meeting picker replaces the title field when
            // the named_meetings flag is on.
            namedMeetings: false,
            meetingChoice: null,
            joinError: "",
        };

        APP.store.subscribe(() => {
            this.setState({
                userCreated: APP.store["features/base/settings"]?.user,
            });
        });

        this._closeDialog = this._closeDialog.bind(this);
        this._showDialog = this._showDialog.bind(this);
        this._onJoinButtonClick = this._onJoinButtonClick.bind(this);
        this._onDropdownClose = this._onDropdownClose.bind(this);
        this._onOptionsClick = this._onOptionsClick.bind(this);
        this._setName = this._setName.bind(this);
        this._onToolbarOpenInvite = this._onToolbarOpenInvite.bind(this);
        this._onJoinConferenceWithoutAudioKeyPress =
            this._onJoinConferenceWithoutAudioKeyPress.bind(this);
        this._showDialogKeyPress = this._showDialogKeyPress.bind(this);
        this._onJoinKeyPress = this._onJoinKeyPress.bind(this);
        this._getExtraJoinButtons = this._getExtraJoinButtons.bind(this);
        this._openProfileModal = this._openProfileModal.bind(this);
        this.handleOpenCodec = this.handleOpenCodec.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this._onMeetingChoice = this._onMeetingChoice.bind(this);

        this.showDisplayNameField =
            props.canEditDisplayName || props.showErrorOnJoin;
    }
    _onToolbarOpenInvite: () => void;

    /**
     * Creates an analytics toolbar event and dispatches an action for opening
     * the modal for inviting people directly into the conference.
     *
     * @private
     * @returns {void}
     */
    _onToolbarOpenInvite() {
        sendAnalytics(createToolbarEvent("invite"));
        this.props.beginAddPeople(this.state.name, false, true, false);
    }

    _openProfileModal: () => void;

    _openProfileModal() {
        this.props.editProfile();
    }

    _openSecurityModal: () => void;

    _openSecurityModal() {
        this.props.editScurity();
    }

    doLogOut: () => void;

    doLogOut() {
        this.props.updateSettings({ user: "" });
    }

    _onJoinButtonClick: () => void;

    /**
     * Handler for the join button.
     *
     * @param {Object} e - The synthetic event.
     * @returns {void}
     */
    /*     _onJoinButtonClick() {
        if (this.props.showErrorOnJoin) {
            return;
        }
        this.props.joinConference();
    } */

    _onMeetingChoice: (Object) => void;

    /**
     * Receives the meeting picker's current choice.
     *
     * @param {Object} choice - { meetingId, label } or { newName, label }, or null.
     * @returns {void}
     */
    _onMeetingChoice(choice) {
        this.setState({
            meetingChoice: choice,
            name: choice ? choice.label : "",
            error: false,
            joinError: "",
        });
    }

    _onJoinButtonClick() {
        const room = this.props.roomId;
        const { userInviteList, userCreated, clearInvitedUsers } = this.props;
        const { namedMeetings, meetingChoice } = this.state;
        let ToSendUserInviteList = [
            ...userInviteList,
            ...this.state.toInvitePreviousMembersList,
        ];
        const canStart = namedMeetings
            ? Boolean(meetingChoice && (meetingChoice.meetingId || (meetingChoice.newName || "").trim()))
            : Boolean(this.state.name);
        const meetingTarget = !namedMeetings || !meetingChoice
            ? {}
            : meetingChoice.meetingId
                ? { meetingId: meetingChoice.meetingId }
                : { newName: (meetingChoice.newName || "").trim() };
        this.setState({
            error: !canStart,
            joinError: "",
        });
        if (!namedMeetings) {
            jitsiLocalStorage.setItem("gaglTitleName", this.state.name);
        }
        if (canStart) {
            this.setState({
                loading: true,
            });
            meetingService
                .joinMeeting({
                    ...meetingTarget,
                    members: ToSendUserInviteList.map(item => {
                        return {
                            email: item.email,
                            name: item.name,
                            msg: item.msg,
                        };
                    }),
                    invitedMembers: userInviteList.map((item) => {
                        return {
                            email: item.email,
                            name: item.name,
                            msg: item.msg,
                        };
                    }),
                    user_created: userCreated,
                    mode: this.state.moderatorMode.value
                })
                .then((res) => {
                    clearInvitedUsers()
                    const moderator = res.data.members.find(
                        (item) => item.role === "moderator"
                    );
                    if (moderator) {
                        window.location.href = moderator.meeting_panther?.fullURL;
                        // window.location.href = moderator.meeting_panther?.fullURL?.replace("comrex-dev.panthermediasystem.net", "localhost:8080");
                    }
                    // if (onSubmit) {
                    //     onSubmit(room);
                    // }
                })
                .catch((error) => {
                    console.log({ error });
                    if (namedMeetings) {
                        this.setState({ joinError: meetingErrorText(error) });
                    }
                })
                .finally(() => {
                    this.setState({
                        loading: false,
                    });
                });
        }
    }

    _onJoinKeyPress: (Object) => void;

    /**
     * KeyPress handler for accessibility.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _onJoinKeyPress(e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            this._onJoinButtonClick();
        }
    }

    _onDropdownClose: () => void;

    /**
     * Closes the dropdown.
     *
     * @returns {void}
     */
    _onDropdownClose() {
        this.setState({
            showJoinByPhoneButtons: false,
        });
    }

    _onOptionsClick: () => void;

    /**
     * Displays the join by phone buttons dropdown.
     *
     * @param {Object} e - The synthetic event.
     * @returns {void}
     */
    _onOptionsClick(e) {
        e.stopPropagation();

        this.setState({
            showJoinByPhoneButtons: !this.state.showJoinByPhoneButtons,
        });
    }

    _setName: () => void;

    /**
     * Sets the guest participant name.
     *
     * @param {string} displayName - Participant name.
     * @returns {void}
     */
    /*     _setName(displayName) {
        this.props.updateSettings({
            displayName
        });
    } */

    _setName(name) {
        this.setState({
            name: name.slice(0, 200),
        });
    }

    _closeDialog: () => void;

    /**
     * Closes the join by phone dialog.
     *
     * @returns {undefined}
     */
    _closeDialog() {
        this.props.setJoinByPhoneDialogVisiblity(false);
    }

    _showDialog: () => void;

    /**
     * Displays the dialog for joining a meeting by phone.
     *
     * @returns {undefined}
     */
    _showDialog() {
        this.props.setJoinByPhoneDialogVisiblity(true);
        this._onDropdownClose();
    }

    handleOpenCodec() {
        sendAnalytics(createToolbarEvent("invite"));
        this.props.beginAddPeople("", true, false, true);
    }
    handleChange(value) {
        this.setState({ moderatorMode: value });
        console.log("value ========>", value);
        this.props.updateSettings({ mode: value?.value });
        if (value.value === "silent") {
            APP.store.dispatch(
                muteLocal(true, MEDIA_TYPE.AUDIO, "local", true)
            );
        } else {
            APP.store.dispatch(
                muteLocal(false, MEDIA_TYPE.AUDIO, "local", true)
            );
        }
    }

    _showDialogKeyPress: (Object) => void;

    /**
     * KeyPress handler for accessibility.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _showDialogKeyPress(e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            this._showDialog();
        }
    }

    _onJoinConferenceWithoutAudioKeyPress: (Object) => void;

    /**
     * KeyPress handler for accessibility.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    _onJoinConferenceWithoutAudioKeyPress(e) {
        if (
            this.props.joinConferenceWithoutAudio &&
            (e.key === " " || e.key === "Enter")
        ) {
            e.preventDefault();
            this.props.joinConferenceWithoutAudio();
        }
    }

    _getExtraJoinButtons: () => Object;

    /**
     * Gets the list of extra join buttons.
     *
     * @returns {Object} - The list of extra buttons.
     */
    _getExtraJoinButtons() {
        const { joinConferenceWithoutAudio, t } = this.props;

        const noAudio = {
            key: "no-audio",
            testId: "prejoin.joinWithoutAudio",
            icon: IconVolumeOff,
            label: t("prejoin.joinWithoutAudio"),
            onClick: joinConferenceWithoutAudio,
            onKeyPress: this._onJoinConferenceWithoutAudioKeyPress,
        };

        const byPhone = {
            key: "by-phone",
            testId: "prejoin.joinByPhone",
            icon: IconPhoneRinging,
            label: t("prejoin.joinAudioByPhone"),
            onClick: this._showDialog,
            onKeyPress: this._showDialogKeyPress,
        };

        return {
            noAudio,
            byPhone,
        };
    }

    componentDidMount() {
        flagsService.getFlags().then((flags) => {
            this.setState({ namedMeetings: flags.named_meetings === true });
        });
        axios
            .get(
                // `${process.env.REACT_APP_DOMAIN || 'https://gagl-api.comrex.com/api' }/meeting/get-all-previous-members`
                `${process.env.REACT_APP_DOMAIN || 'https://comrex-api-dev.panthermediasystem.net/api' }/meeting/get-all-previous-members`
            )
            .then((res) => {
                const members = res.data.members.filter((item, index) => {
                    // return true
                    if (item.role === "guest") {
                        return true;
                    }
                });
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        previousmembers: members,
                    };
                });
                // setPreviousMembers(members)
            })
            .catch((err) => {
                console.log("error occurred", err);
            });
    }
    setPreviousUserInviteList(user) {
        let userToPush = [...this.state.toInvitePreviousMembersList];
        let clickUserToPush = [...this.state.clickedUser];
        const { name, email } = user;
        if (userToPush.length) {
            userToPush.map((item, index) => {
                if (item.email === email) {
                    userToPush.splice(index, 1);
                } else {
                    userToPush.push({ name: name, email: email });
                }
            });
        } else {
            userToPush.push({ name: name, email: email });
        }
        if (clickUserToPush.length) {
            clickUserToPush.map((item, index) => {
                if (item === email) {
                    clickUserToPush.splice(index, 1);
                } else {
                    clickUserToPush.push(email);
                }
            });
        } else {
            clickUserToPush.push(email);
        }

        this.setState((prev) => {
            return {
                ...prev,
                toInvitePreviousMembersList: userToPush,
                clickedUser: clickUserToPush,
            };
        });
    }
    setResendInvitationLink() {
        if (this.state.toInvitePreviousMembersList.length) {
            this.setState((prev) => {
                return {
                    resendInviteClicked: true,
                };
            });
        }
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const {
            name,
            showAvatar,
            showCameraPreview,
            showConferenceInfo,
            showJoinActions,
            t,
            videoTrack,
            page,
            roomId,
            userCreated,
            avatarUrl,
        } = this.props;
        const { _onJoinButtonClick, _setName } = this;
        const { showError, loading } = this.state;
        const mode = [
            {
                label: "participant".toUpperCase(),
                value: "participant",
            },
            {
                label: "silent".toUpperCase(),
                value: "silent",
            },
            {
                label: "producer".toUpperCase(),
                value: "producer",
                isDisabled: true,
            },
        ];
        return (
            <>
                {
                    page === 'welcome' && ( <PreMeetingScreen
                        footer={this._renderFooter()}
                        name={name}
                        avatarUrl={avatarUrl}
                        user={userCreated.userName}
                        showAvatar={showAvatar}
                        showConferenceInfo={showConferenceInfo}
                        showJoinActions={showJoinActions}
                        skipPrejoinButton={this._renderSkipPrejoinButton()}
                        title={t("prejoin.joinMeeting")}
                        videoMuted={!showCameraPreview}
                        videoTrack={videoTrack}
                    >
                        <div
                            className={
                                "account-setting-dropdown account-setting-custom"
                            }
                        >
                            <div
                                style={{ marginRight: 10 }}
                                className={"account-display-custom"}
                            >
                                Hi, {userCreated.userName}
                            </div>
                            <LogoutButton
                                isMod={true}
                                avatarUrl={avatarUrl}
                                handleProfile={() =>
                                    this._openProfileModal()
                                }
                                handleSecurity={() =>
                                    this._openSecurityModal()
                                }
                                handleLogout={() => this.doLogOut()}
                            />
                        </div>
                        {showJoinActions && (
                            <div>
                                <div className="flex-row jus-between padding-codec">
                                    {/* <div className = 'login-setup'>*/}
                                    {/*   {t('login.audioSetup')}*/}
                                    {/* </div>*/}
                                    {/*<div*/}
                                    {/*    className = 'login-setup mt-600'*/}
                                    {/*    onClick = { this.handleOpenCodec }>*/}
                                    {/*    {t('login.codecSetup')}*/}
                                    {/*</div>*/}
                                </div>
                                <div className="prejoin-input-area-container prejoin-input-area-logged-in">
                                    <div className="start-meeting-label">
                                        {/* {t('login.startMeeting')} */}
                                    </div>
                                    <div style={{ height: 20 }} />
                                    {/* <CopyMeetingUrl roomId = { roomId } />*/}

                                    <div style={{ height: 10 }} />
                                    <div
                                        className={"input-field-premeeting"}
                                    >
                                        {this.state.namedMeetings ? (
                                            <MeetingPicker
                                                disabled={loading}
                                                onChange={this._onMeetingChoice}
                                            />
                                        ) : (
                                            <InputField
                                                autoFocus={true}
                                                className={
                                                    showError ? "error" : ""
                                                }
                                                hasError={showError}
                                                onChange={_setName}
                                                placeHolder={t(
                                                    "dialog.enterMeetingTitle"
                                                )}
                                                value={this.state.name}
                                            />
                                        )}
                                        {this.state.error && (
                                            <div style={{ color: "red" }}>
                                                {this.state.namedMeetings
                                                    ? "Choose a meeting or enter a name for a new one."
                                                    : t("dialog.meetingError")}
                                            </div>
                                        )}
                                        {this.state.joinError && (
                                            <div style={{ color: "red" }}>
                                                {this.state.joinError}
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ height: 10 }} />
                                    <ActionButton
                                        className="button-invite"
                                        hasOptions={true}
                                        onClick={this._onToolbarOpenInvite}
                                        OptionsIcon={IconPlus}
                                        testId="prejoin.invite.joinMeeting"
                                        type="primary"
                                    >
                                        {t("addPeople.title")}
                                    </ActionButton>
                                    <div className={"select-mode"}>
                                        <Select
                                            inputId="multi-select-example"
                                            className="multi-select"
                                            classNamePrefix="react-select"
                                            options={mode}
                                            value={this.state.moderatorMode}
                                            onChange={(value) =>
                                                this.handleChange(value)
                                            }
                                            isMulti={false}
                                            isSearchable={false}
                                            placeholder="Choose a mode of moderator before you start a meeting"
                                        />
                                    </div>
                                    {this.state.previousmembers.length &&
                                    !this.state.resendInviteClicked
                                        ? this.state.previousmembers.map(
                                            (item, index) => (
                                                <p
                                                    onClick={() =>
                                                        this.setPreviousUserInviteList(
                                                            item
                                                        )
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            this.state.clickedUser.includes(
                                                                item.email
                                                            )
                                                                ? "#093452"
                                                                : null,
                                                        padding: "10px",
                                                        cursor: "pointer",
                                                        width: "14rem",
                                                        marginTop: "10px",
                                                        border: !this.state.clickedUser.includes(
                                                            item.email
                                                        )
                                                            ? "1px solid grey"
                                                            : null,
                                                    }}
                                                    title={
                                                        this.state.clickedUser.includes(
                                                            item.email
                                                        )
                                                            ? "Unselect User"
                                                            : "Select User"
                                                    }
                                                >
                                                    {item.email}
                                                </p>
                                            )
                                        )
                                        : null}

                                    {this.state.previousmembers.length ? (
                                        <div
                                            className="prejoin-preview-dropdown-container"
                                            style={{ marginTop: 20 }}
                                        >
                                            {!this.state
                                                .resendInviteClicked ? (
                                                <ActionButton
                                                    className="button-login-meeting"
                                                    onClick={
                                                        this.state.loading
                                                            ? undefined
                                                            : () =>
                                                                this.setResendInvitationLink()
                                                    }
                                                    testId="prejoin.joinMeeting"
                                                    type="primary"
                                                >
                                                    Resend Invites
                                                    {/* {t('login.startMeeting')} */}
                                                </ActionButton>
                                            ) : (
                                                <ActionButton
                                                    className="button-login-meeting"
                                                    testId="prejoin.joinMeeting"
                                                    type="primary"
                                                >
                                                    Invitation sent
                                                    {/* {t('login.startMeeting')} */}
                                                </ActionButton>
                                            )}
                                        </div>
                                    ) : null}

                                    <div
                                        className="prejoin-preview-dropdown-container"
                                        style={{ marginTop: 20 }}
                                    >
                                        <ActionButton
                                            className="button-login-meeting"
                                            onClick={
                                                this.state.loading
                                                    ? undefined
                                                    : _onJoinButtonClick
                                            }
                                            testId="prejoin.joinMeeting"
                                            type="primary"
                                        >
                                            {t("login.startMeeting")}
                                        </ActionButton>
                                    </div>
                                    <div
                                        className="toolbox-content-items"
                                        style={{
                                            marginTop: 20,
                                            marginBottom: 10,
                                        }}
                                    >
                                        {/*<AudioSettingsButton*/}
                                        {/*    isShowPopup = { true }*/}
                                        {/*    visible = { true } />*/}
                                        {/* <VideoSettingsButton visible = { true } />*/}
                                    </div>
                                    <div className="prejoin-bottom-info" />
                                </div>
                            </div>
                        )}
                        {/* {showDialog && (*/}
                        {/* <JoinByPhoneDialog*/}
                        {/* joinConferenceWithoutAudio = { joinConferenceWithoutAudio }*/}
                        {/* onClose = { _closeDialog } />*/}
                        {/* )}*/}
                    </PreMeetingScreen> )
                }
                {loading && (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            backgroundColor: "rgba(0,0,0,0.2)",
                            zIndex: 9999999999,
                            justifyContent: "center",
                            alignItems: "center",
                            position: 'fixed',
                            left: 0,
                            top: 0,
                            overflow: 'hidden',
                        }}
                    >
                        <Spinner size="large" />
                    </div>
                )}
            </>
        );
    }

    /**
     * Renders the 'skip prejoin' button.
     *
     * @returns {React$Element}
     */
    _renderSkipPrejoinButton() {
        const { buttonIsToggled, t, showSkipPrejoin } = this.props;

        if (!showSkipPrejoin) {
            return null;
        }

        return (
            <div className="prejoin-checkbox-container">
                <ToggleButton
                    isToggled={buttonIsToggled}
                    onClick={this._onToggleButtonClick}
                >
                    {t("prejoin.doNotShow")}
                </ToggleButton>
            </div>
        );
    }

    /**
     * Renders the screen footer if any.
     *
     * @returns {React$Element}
     */
    _renderFooter() {
        return this.props.deviceStatusVisible && <DeviceStatus />;
    }
}

/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps): Object {
    const name = getDisplayName(state);
    const showErrorOnJoin = isDisplayNameRequired(state) && !name;
    const { id: participantId } = getLocalParticipant(state);
    const { joiningInProgress } = state["features/prejoin"];
    const { showJoinActions } = ownProps;
    const isInviteButtonEnabled = isButtonEnabled("invite", state);
    const userInviteList = state["features/invite"].invitedUserList;
    const settings = state["features/base/settings"];
    const { locationURL } = state["features/base/connection"];
    const moderatorMode = state["features/base/settings"].mode;
    const user = state["features/base/settings"].user;

    return {
        locationURL,
        userCreated: settings.user,
        userInviteList,
        name,
        canEditDisplayName: isPrejoinDisplayNameVisible(state),
        deviceStatusVisible: isDeviceStatusVisible(state),
        roomName: getRoomName(state),
        hasJoinByPhoneButton: isJoinByPhoneButtonVisible(state),
        joiningInProgress,
        participantId,
        prejoinConfig: state["features/base/config"].prejoinConfig,
        readOnlyName: isNameReadOnly(state),
        showCameraPreview: !isVideoMutedByUser(state),
        showDialog: isJoinByPhoneDialogVisible(state),
        showErrorOnJoin,
        avatarUrl: getLocalParticipant(state).loadableAvatarUrl,
        videoTrack: getLocalJitsiVideoTrack(state),
        moderatorMode,
        _user: user,
    };
}

const mapDispatchToProps = {
    joinConferenceWithoutAudio: joinConferenceWithoutAudioAction,
    joinConference: joinConferenceAction,
    setJoinByPhoneDialogVisiblity: setJoinByPhoneDialogVisiblityAction,
    updateSettings,
    beginAddPeople: beginAddPeopleAction,
    clearInvitedUsers: clearAllInvitedUsers,
    editProfile: editProfileAction,
    editScurity: editScurityAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(translate(Prejoin));
